import { Button, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { useNavigate } from 'react-router-dom';
import { RoutesConfig } from 'Routes';

interface IContinueRequest {
  getFilesList: () => void;
  isValid: boolean;
}

export const ContinueRequest = ({
  getFilesList,
  isValid,
}: IContinueRequest) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.DOCUMENTS_HANDLE);
  const navigate = useNavigate();

  return (
    <Stack
      gap='20px'
      justifyContent='center'
      sx={{
        m: '48px auto',
        maxWidth: '340px',
      }}
    >
      <Button onClick={getFilesList}>{dictionary.checkFiles}</Button>
      {isValid ? (
        <>
          <Button onClick={() => navigate(RoutesConfig.VERIFY_DETAILS.PATH)}>
            {dictionary.continueRequest}
          </Button>
        </>
      ) : (
        <Typography color='#A30F28' textAlign='center' role='alert'>
          {dictionary.continueRequestNote}
        </Typography>
      )}
    </Stack>
  );
};
